{
	"error": {
		"title": "Oops... Something didn't go as planned.",
		"description": "Could not complete."
	},
	"success": "Successfully concluded!"
}
